import { BrowserRouter, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import ScrollToTop from "react-scroll-to-top";

// Import all route components directly (no lazy loading for now)
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import CaseStudyDetails from "./pages/CaseStudyDetails";
import Contact from "./pages/Contact";
import HomeFour from "./pages/HomeFour";
import HomeOne from "./pages/HomeOne";
import HomeThree from "./pages/HomeThree";
import HomeTwo from "./pages/HomeTwo";
import Service from "./pages/Service";
import ServiceDetails from "./pages/ServiceDetails";
import Team from "./pages/Team";
import TeamDetails from "./pages/TeamDetails";
import ApplyForm from "./pages/ApplyForm";
import Portfolio from "./pages/Portfolio";
import Career from "./pages/Career";
import TeamDetailsSingle from "./pages/TeamDetailsSingle";
import Innovation from "./pages/Innovation";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import JumpStart from "./pages/JumpStart";
import FundBoost from "./pages/FundBoost";
import FundAdvisory from "./pages/FundAdvisory";
import DevSprint from "./pages/DevSprint";
import DevBuild from "./pages/DevBuild";
import DevScale from "./pages/DevScale";
import HomeFive from "./pages/HomeFive";
import FundingLab from "./pages/FundingLab";
import FundingLabEnroll from "./pages/FundingLabEnroll";
import FundingLabWelcome from "./pages/FundingLabWelcome";
import NotFound from "./pages/NotFound";

function App() {
  useEffect(() => {
    // react-snap crawls with this user agent. AOS mutates the DOM outside
    // React's own render (adds aos-init/aos-animate classes imperatively), so
    // running it during the prerender crawl bakes those classes into the
    // static HTML — then real hydration sees DOM that doesn't match React's
    // own render output and throws hydration-mismatch errors (#418/#423/#425),
    // silently discarding the prerendered markup and forcing a full client
    // re-render. Skipping AOS during the crawl keeps prerendered HTML clean.
    if (navigator.userAgent === "ReactSnap") return;

    AOS.init({
      offset: 0,
      easing: "ease",
      once: true,
    });
    AOS.refresh();
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<HomeFive />} />
        <Route exact path="/index-2" element={<HomeTwo />} />
        <Route exact path="/index-3" element={<HomeThree />} />
        <Route exact path="/index-4" element={<HomeFour />} />
        <Route exact path="/index-5" element={<HomeOne />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/blog" element={<Blog />} />
        <Route exact path="/blog-details" element={<BlogDetails />} />
        <Route
          exact
          path="/case-study-details"
          element={<CaseStudyDetails />}
        />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/service" element={<Service />} />
         <Route exact path="/service-details" element={<ServiceDetails />} />
        <Route exact path="/funding/jumpstart" element={<JumpStart />} />
        <Route exact path="/funding/boost" element={<FundBoost />} />
        <Route exact path="/funding/advisory" element={<FundAdvisory />} />
        <Route exact path="/accelerator/dev-sprint" element={<DevSprint />} />
        <Route exact path="/accelerator/dev-build" element={<DevBuild />} />

        <Route exact path="/accelerator/dev-scale" element={<DevScale />} />
        <Route exact path="/funding/launch" element={<ServiceDetails />} />
        <Route exact path="/fundinglab" element={<FundingLab />} />
        <Route exact path="/fundinglab/enroll" element={<FundingLabEnroll />} />
        <Route exact path="/fundinglab/welcome" element={<FundingLabWelcome />} />
        
        <Route exact path="/team" element={<Team />} />
        <Route exact path="/team-details" element={<TeamDetails />} />
        <Route exact path="/apply" element={<ApplyForm />} />
        <Route exact path="/portfolio" element={<Portfolio />} />
        <Route exact path="/careers" element={<Career />} />
        <Route exact path="/team/:id" element={<TeamDetailsSingle />} />
        <Route exact path="/innovation" element={<Innovation />} />
        <Route exact path="/terms" element={<Terms />} />
        <Route exact path="/privacy" element={<Privacy />} />
        <Route exact path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ScrollToTop smooth color="#246BFD" />
    </BrowserRouter>
  );
}

export default App;
